const ADDRESS_SEARCH_VISITED = 'addressSearchVisited';

export const isFirstVisitSearchAddress = (): boolean => {
  if (!localStorage.getItem(ADDRESS_SEARCH_VISITED)) {
    window.localStorage.setItem(ADDRESS_SEARCH_VISITED, ADDRESS_SEARCH_VISITED);
    return true;
  }
  return false;
};
